<template>
	<div>
		<b-row>
			<b-col md="12" class="mb-4">
				<h6>Null</h6>
				<prep-instructors-selectbox v-model="value1"/>
				<span>{{ value1 }}</span>
			</b-col>
			<b-col md="12" class="mb-4">
				<h6>Single Selected</h6>
				<prep-instructors-selectbox v-model="value2"/>
				<span>{{ value2 }}</span>
			</b-col>
			<b-col md="12" class="mb-4">
				<h6>Validate Error</h6>
				<prep-instructors-selectbox v-model="value3" :validate-error="value3ValidateError"/>
				<span>{{ value3 }}</span>
			</b-col>
			<b-col cols="12">
				<b-button variant="primary" @click="change()">
					{{ $t('change') }}
				</b-button>
			</b-col>
		</b-row>
	</div>
</template>
<script>
	import PrepInstructorsSelectbox from "@/components/interactive-fields/PrepInstructorsSelectbox";

	export default {
		components: {
			PrepInstructorsSelectbox,
		},
		data() {
			return {
				value1: null,
				value2: 1,
				value3: 1,
				value3ValidateError: 'Validate Error is Working',
			}
		},
		methods: {
			change() {
				this.value1 = 1
				this.value2 = 1
				this.value3 = 1
				this.value3ValidateError = 'Error'
			}
		}
	};
</script>

